// External modules
import React from 'react';

// Internal modules
import { features, getContent } from '@/lib';
import { LegalAgeDisclosureContainer } from './StyledComponents';

export const LegalAgeDisclosure = (): React.ReactElement => {
  const showDisclosure =
    features.isActive('shouldShowLegalAgeDisclosure') &&
    features.allNotActive(
      'isForcedSignUp',
      'passwordlessForcedSignup',
      'isStreamlineOptionalExperience',
    );

  return (
    <>
      {showDisclosure && (
        <LegalAgeDisclosureContainer data-testid="legal-age-disclosure">
          {getContent('compliance.legalAgeDisclosure')}
        </LegalAgeDisclosureContainer>
      )}
    </>
  );
};
